export default {
  back: 'Zurück zu den Kampagnen',
  title: 'Kampagne',
  sent_at: 'Gesendet {{time}}',
  breakdown_title: 'Zustellungsübersicht',
  pending_receipts: {
    title: 'Zustellungsstatistiken werden geladen',
    description:
      'Diese Kampagne wurde gerade gesendet. Push-Anbieter bestätigen die Zustellung etwa 15 Minuten nach dem Versand, daher werden die Zahlen unten gegen {{time}} gefüllt – nichts zu tun.',
    countdown:
      'Apple und Google bestätigen den Empfang in ungefähr {{minutes}}m {{seconds}}s (gegen {{time}}). Die Statistiken werden automatisch aktualisiert.',
    ready: 'Die Bestätigungen sollten eingetroffen sein. Die Zahlen unten werden gerade aktualisiert.',
    soon: 'in Kürze',
  },
  recipients: {
    title: 'Empfänger',
    subtitle: 'An wen diese Kampagne gesendet wurde und ob sie das Gerät erreicht hat.',
    filters: {
      all: 'Alle',
      delivered: 'Zugestellt',
      pending: 'Wartet auf Bestätigung',
      failed: 'Nicht zugestellt',
    },
    columns: {
      recipient: 'Empfänger',
      status: 'Status',
      reason: 'Grund',
      clicked: 'Geklickt',
      sent_at: 'Gesendet am',
    },
    status: {
      delivered: 'Zugestellt',
      pending: 'Wartet auf Bestätigung',
      failed: 'Nicht zugestellt',
    },
    reasons: {
      DeviceNotRegistered: 'App entfernt oder Benachrichtigungen deaktiviert (Token abgelaufen)',
      MessageRateExceeded: 'Vorübergehend von Expo gedrosselt',
      MessageTooBig: 'Benachrichtigungsinhalt zu groß',
      MismatchSenderId: 'Push-Anmeldedaten stimmen nicht überein',
      InvalidCredentials: 'Ungültige Push-Anmeldedaten',
      batch_failed: 'Senden des Stapels fehlgeschlagen',
      missing_ticket: 'Keine Bestätigung von Expo erhalten',
      unknown: 'Unbekannter Zustellungsfehler',
    },
  },
};
